<h1 class="h3 card-title text-center my-3">Choose Login Type</h1>
<button class="btn btn-lg btn-outline-primary w-100 my-3" (click)="testUserLogin()">Test Login as Educator</button>
<button class="btn btn-lg btn-outline-primary w-100" (click)="standardLogin()">Login via ADEConnect</button>
